<template>
  <div class="title">
    <div class="leyenda">
      <p>Registros</p>
      <p>Promocionales</p>
    </div>
    <div class="boton">
      <b-button variant="primary" 
        class="px-4"
        @click.prevent="login">Ingresar</b-button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Home',

  data () {
    return {
    }
  },
  methods: {
    login (){
      this.$store.dispatch('user/alive')
        .then(() => {
          alert('Its Alive');
          this.$auth.login();
        })
        .catch (error => {
          alert(error);
        })

      // this.$auth.login();
    }
  }
}
</script>

<style>
</style>